//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Translatable from '../../mixins/translatable'

export default {
  name: 'parallax',

  mixins: [Translatable],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },

    src: {
      type: String,
      required: true
    }
  },

  computed: {
    styles () {
      return {
        display: 'block',
        transform: `translate3d(-50%, ${this.parallax}px, 0)`
      }
    }
  },

  methods: {
    init () {
      if (this.$refs.img.complete) {
        this.translate()
        this.listeners()
      }

      this.$refs.img.addEventListener('load', () => {
        this.translate()
        this.listeners()
      }, false)
    },

    objHeight () {
      return this.$refs.img.naturalHeight
    },

    elOffsetTop () {
      return this.$el.offsetTop
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/parallax/Parallax.vue